import { render, staticRenderFns } from "./TaxonomySingleProducts.vue?vue&type=template&id=481822bb&"
import script from "./TaxonomySingleProducts.vue?vue&type=script&lang=js&"
export * from "./TaxonomySingleProducts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports